import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'firstLetterUppercase' })
export class FirstUppercasePipe implements PipeTransform {
  transform(value: string): string {
    value = value?.split('%20')?.join(' ');
    value = value?.split('%2520')?.join(' ');
    value = value?.split('%252520')?.join(' ');
    value = `${value?.charAt(0).toUpperCase()}${value?.slice(1)}`;
    return value;
  }
}
